import React, { useEffect, useState, createContext, useContext } from 'react';
import axios from 'axios';
import configData from '../config.json';

export const RestaurantContext = createContext();

export function RestaurantWrapper({ children }) {
  const [fetching, setFetching] = useState(true);
  const [restaurant, setRestaurant] = useState(null);
  const [restaurants, setRestaurants] = useState([]);
  const [checkoutStep, setCheckoutStep] = useState('choose-order');

  const fetchRestaurants = async (value) => {
    try {
      let token = '';
      let user = localStorage.getItem('user_profile');
      if (user) {
        user = JSON.parse(user);
        token = user.token;
      }

      const response = await axios.post(`${configData.SERVER_URL}/mobile/restaurant/fetch`, value, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const sortedRestaurants = sortRestaurants(response.data);
      setRestaurants(sortedRestaurants);
      setFetching(false);
      return sortedRestaurants;
    } catch (error) {
      console.error('Error fetching restaurants:', error);
      setFetching(false);
      return [];
    }
  };

  const sortRestaurants = (restaurants) => {
    return restaurants.sort((a, b) => {
      if (a.distance == null || b.distance == null) {
        return 0;
      }
      const distanceA = parseFloat(a?.distance?.replace('km', '') || 0);
      const distanceB = parseFloat(b?.distance?.replace('km', '') || 0);

      return distanceA - distanceB;
    });
  };

  const getCurrentLocation = () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            window.localStorage.setItem('position', JSON.stringify({ latitude, longitude }));
            resolve({ latitude, longitude });
          },
          (error) => {
            console.warn('Geolocation error:', error);
            resolve({ latitude: 0, longitude: 0 });
          },
        );
      } else {
        resolve({ latitude: 0, longitude: 0 });
      }
    });
  };

  const loadRestaurants = async (ignoreDineinTakeout = true) => {
    setFetching(true);

    // First try to get location from cache
    const locCache = window.localStorage.getItem('position');
    let coordinates;

    if (locCache) {
      const loc = JSON.parse(locCache);
      coordinates = [loc.longitude, loc.latitude];
    } else {
      // If no cache, try to get current location
      const location = await getCurrentLocation();
      coordinates = [location.longitude, location.latitude];
    }

    const payload = {
      ignoreDineinTakeout,
      geoLocation: {
        coordinates,
      },
    };

    return await fetchRestaurants(payload);
  };

  return (
    <RestaurantContext.Provider
      value={{
        restaurants,
        setRestaurants,
        fetching,
        setFetching,
        loadRestaurants,
        fetchRestaurants,
        checkoutStep,
        setCheckoutStep,
        restaurant,
        setRestaurant,
      }}
    >
      {children}
    </RestaurantContext.Provider>
  );
}

export function useRestaurantContext() {
  return useContext(RestaurantContext);
}
